<template>
  <div class="checkbox-list">
    <CheckboxGroup v-model="selectReport" @change="reportSelected(selectReport)">
      <Checkbox label="Indent Status Report">
        Indent Status Report
      </Checkbox>
      <Checkbox label="Contract Adherence Report">
        Contract Adherence Report
      </Checkbox>
      <Checkbox label="Exim Indent Status Report">
        Exim Indent Status Report
      </Checkbox>
      <Checkbox label="Exim Air Movement Import Report">
        Exim Air Movement Import Report
      </Checkbox>
      <Checkbox label="Exim Air Movement Export Report">
        Exim Air Movement Export Report
      </Checkbox>
      <Checkbox label="Inbound Indent Status">
        Inbound Indent Status
      </Checkbox>
      <Checkbox label="Outlier Report">
        Outlier Report
      </Checkbox>
      <Checkbox label="Delay Report" >
        Delay Report
      </Checkbox>
      <Checkbox label="Transporter Performance">
        Transporter performance
      </Checkbox>
      <Checkbox label="Indents without Materials">
        Indents without Materials
      </Checkbox>
      <!-- <Checkbox label="Transit Delay" disabled>
        Transit Delay
      </Checkbox> -->
      <Checkbox label="GIT Report">
        GIT Report
      </Checkbox>
      <Checkbox label="Transit Reliability Report">
        Transit Reliability Report
      </Checkbox>
      <!-- <Checkbox label="Primary Active Orders Detention Delay" disabled>
        Primary Active Orders Detention Delay
      </Checkbox>
      <Checkbox label="Primary Delivered Orders Detention Delay" disabled>
        Primary Delivered Orders Detention Delay
      </Checkbox> -->
      <Checkbox label="Shipment Unmapped Report">
        Shipment Unmapped Report
      </Checkbox>
      <Checkbox label="Movement Data">
        Movement Data
      </Checkbox>
      <Checkbox label="Capacity Utilisation">
        Capacity Utilisation
      </Checkbox>
      <Checkbox label="Unknown Materials">
        Unknown Materials
      </Checkbox>
      <Checkbox label="Material Invoice and Freight Spent">
        Material Invoice and Freight Spent
      </Checkbox>
      <Checkbox label="Optima Variance Report">
        Optima Variance Report
      </Checkbox>
      <!-- <Checkbox label="Weekly Performance" disabled>
        Weekly Performance
      </Checkbox>
      <Checkbox label="Delivered Indents" disabled>
        Delivered Orders
      </Checkbox>
      <Checkbox label="Vendor Dashboard" disabled>
        Transporter Dashboard
      </Checkbox>
      <Checkbox label="Orders Without Materials" disabled>
        Indents Without Materials
      </Checkbox>
      <Checkbox label="Unknown Materials" disabled>
        Unknown Materials
      </Checkbox> -->
      <Checkbox label="Indents Count">
        Indents Count
      </Checkbox>
      <Checkbox label="Freight Provision">
        Freight Provision
      </Checkbox>
      <Checkbox label="BUCC Bifurcation">
        BUCC Bifurcation
      </Checkbox>

      <Checkbox label="Open market placements">
        Open market placements
      </Checkbox>
      <Checkbox label="Optima Vs Dispatch Materials">
        Optima Vs Dispatch Materials
      </Checkbox>
      <Checkbox label="Vehicle Types Bifurcation Report">
        Vehicle Types Bifurcation Report
      </Checkbox>
      <Checkbox label="Payment Compliance Report">
        Payment Compliance Report
      </Checkbox>
      <Checkbox label="Total Distance Report">
        Total Distance Report
      </Checkbox>
      <Checkbox label="Track And Trace Report">
        Track And Trace Report
      </Checkbox>
      <Checkbox label="Optima Performance Report For Secondary">
        Optima Performance Report For Secondary
      </Checkbox>
    </CheckboxGroup>
  </div>
</template>

<script>
export default {
  name: 'ReportList',
  data() {
    return {
      selectReport: [],
    };
  },
  methods: {
    reportSelected(selectedReports) {
      this.$emit('selectedReports', selectedReports);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@common/styles-shipper/settings";
.checkbox-list  {
  .el-checkbox {
    width: 325px;
    margin: 5px;
    float: left;
    color: $tertiary-text;
    font-family:$fontSemibold;
    font-size: 1.2rem;
    &-group{
      margin: 10px 0;
    }
  }
}
</style>
